import DynamicForm from "@/common/DynamicForm";
import { IntakeSectionHeader, StyledGridRow } from "@/common/styles";
import { staticFields } from "@/util/common_variable";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "antd";
import { useForm } from "antd/es/form/Form";
import { useEffect, useImperativeHandle } from "react";
import { debounce, getRefListNameByID, isNonEmptyVariable } from "@/util/common_function";
import dayjs from "dayjs";
import _ from "lodash";
import { setBookings } from "@/slices/bookingsSlice";

const OrganizationalRank = ({ header, organizationRankRef }) => {
  const [form] = useForm();
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (isNonEmptyVariable(bookings)) {
      if (bookings?.rankHr?.length && bookings?.organization?.length) {
        if (isNonEmptyVariable(bookings?.rankHr?.[0]?.rankDate)) {
          let copyBookings = _.cloneDeep(bookings);
          copyBookings = {
            ...copyBookings,
            rankHr: [
              {
                ...copyBookings?.rankHr?.[0],
                rankDate: dayjs(copyBookings?.rankHr?.[0]?.rankDate),
              },
            ],
          };
          form.setFieldsValue(copyBookings);
        } else {
          form.setFieldsValue(bookings);
        }
      }
      else {
        form.setFieldsValue(bookings);
      }
    } else {
      form.resetFields();
      console.log("check 4 agency")
    }
    console.log({bookings})
  }, [bookings]);

  const updateForm = debounce(()=>{
          const values = form.getFieldsValue();
 const data = {
      ...values,
      organization: [
        {
          ...bookings?.organization?.[0],
          ...values?.organization?.[0],
          agency: getRefListNameByID("Housing_Agency", values?.organization?.[0]?.agency),
          agencyId: values?.organization?.[0]?.agency,
        },
      ],
      rankHr: [
        {
          ...bookings?.rankHr?.[0],
          ...values?.rankHr?.[0],
          rankDate: isNonEmptyVariable(values?.rankHr?.[0]?.rankDate)
            ? dayjs(values?.rankHr?.[0]?.rankDate)?.format("MM/DD/YYYY")
            : null,
        },
      ],
    };
     dispatch(
      setBookings({
        ...bookings,
        ...data,
      })
    );
    },600)

    // const data = {
    //   ...values,
    //   organization: [
    //     {
    //       ...bookings?.organization?.[0],
    //       ...values?.organization?.[0],
    //       agency: getRefListNameByID("Housing_Agency", values?.organization?.[0]?.agencyId)
    //     },
    //   ],
    //   rankHr: [
    //     {
    //       ...bookings?.rankHr?.[0],
    //       ...values?.rankHr?.[0],
    //       rankDate: isNonEmptyVariable(values?.rankHr?.[0]?.rankDate)
    //         ? dayjs(values?.rankHr?.[0]?.rankDate)?.format("MM/DD/YYYY")
    //         : null,
    //     },
    //   ],
    // };

   
  

  // Expose form methods to parent
  useImperativeHandle(organizationRankRef, () => ({
    submitForm: () => form.submit(),
    resetForm: () => form.resetFields(),
    getFormValues: () => form.getFieldsValue(),
    getFieldsError: () => form.getFieldsError(),
    isFieldsValidating: () => form.isFieldsValidating(),
    validateFields: () => form.validateFields(),
    form: form,
  }));

  return (
    <>
      {header && (
        <IntakeSectionHeader>
          <span>{header}</span>
        </IntakeSectionHeader>
      )}

      <Form
        form={form}
        onFieldsChange={(e) => {
          updateForm();
        }}
        disabled={!bookingsFieldsEnabled}
      >
        <StyledGridRow gutter={[16]}>
          {staticFields?.organizationalRank?.map((sf, index) => {
            return (
              <DynamicForm
                formAttributes={sf}
                key={index}
                form={form}
                bookingsFieldsEnabled={bookingsFieldsEnabled}
              />
            );
          })}
        </StyledGridRow>
      </Form>
    </>
  );
};

export default OrganizationalRank;
